import { render, staticRenderFns } from "./TrainingDescriptionPage.vue?vue&type=template&id=447ac39d&scoped=true&"
import script from "./TrainingDescriptionPage.vue?vue&type=script&lang=js&"
export * from "./TrainingDescriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDescriptionPage.vue?vue&type=style&index=0&id=447ac39d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447ac39d",
  null
  
)

export default component.exports